// ===========================================
// HELPER: mensaje al cliente por recategorización semestral (ORR-238)
// ===========================================
// Función pura que arma el cuerpo del mensaje con los datos que el contador
// carga al marcar presentada la recategorización.
//
// Igual que generarMensajeMonotributo (ver ORR-185): NO incluye el saludo
// "Hola {nombre}" — lo pone el template (EmailLayout) — ni el cierre "Saludos",
// que lo agrega el caller. Incluirlos acá los duplicaría en el mail.

export const CATEGORIAS_MONOTRIBUTO = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K',
] as const

export type CategoriaMonotributo = (typeof CATEGORIAS_MONOTRIBUTO)[number]

export type RegimenRecategorizacion = 'monotributo' | 'monotributo_unificado'

interface DatosMensajeRecategorizacion {
  categoria: CategoriaMonotributo
  regimen: RegimenRecategorizacion
  /** Ya formateado por el caller con formatCurrency (patrón de mensajeMonotributo). */
  monto: string
}

export function generarMensajeRecategorizacion({
  categoria,
  regimen,
  monto,
}: DatosMensajeRecategorizacion): string {
  const base = `Realizamos tu recategorización semestral. De acuerdo a tus parámetros tu nueva categoría es la ${categoria}. El nuevo monto mensual a abonar será de ${monto}.`

  // El párrafo de ingresos brutos va solo en el régimen unificado: en monotributo
  // simple el cliente paga IIBB por separado y mencionarlo confunde.
  if (regimen === 'monotributo_unificado') {
    return `${base} Incluye el monto de ingresos brutos.`
  }

  return base
}
